import { type HttpClient } from '@/application/interfaces/http-client';

import getProfile from './get-profile';

const profileService = (httpClient: HttpClient.Instance) => ({
  getProfile: getProfile(httpClient),
});

export default profileService;
